import React, { FC, ChangeEvent } from 'react'
import { InputPhone } from '../styled'

export interface PhoneProps {
	onChange?: (event: ChangeEvent<HTMLInputElement>) => void
	name: string
	placeholder: string
	measure: string
	mask?: string
	maskChar?: string
}

export const InputComponentPhone: FC<PhoneProps> = ({
	mask,
	maskChar,
	name,
	onChange,
	placeholder,
	measure,
	...props
}) => (
	<InputPhone
		{...props}
		mask={mask}
		maskChar={maskChar}
		name={name}
		onChange={onChange}
		placeholder={placeholder}
		measure={measure}
	/>
)
